function generateId() {
    const S4 = () => (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);

    return new Date().getTime() + S4() + S4();
}

export default generateId;
